const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const getWs02Token = require('@dbk-legacy/wso2token').getToken;
const getIPaddress = require('@dbk-legacy/wso2token').getIPaddress;
const { Base64 } = require('js-base64');

function apiFactory({
  baseUrl,
  requestHandler,
}) {
  const headers = {
    Accept: 'application/json'
  };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {

    initiateDataExtract(metaData) {
      const url = getUrl('initiate-dataextract');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const branchCode = parsedMetaData.portfolio.branchCode === 999999999? parsedMetaData.configBranchCode : parsedMetaData.portfolio.branchCode;
      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: branchCode,
      }
      return requestHandler(merge(
        {},
        reqOpts, { url, body }
      ));
    },

    getExtractVolume(inputParam, metaData) {
      const url = getUrl('get-extract-volume');
      const parsedMetaData = parseRequestMetaData(metaData);

      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const branchCode = parsedMetaData.portfolio.branchCode === 999999999? parsedMetaData.configBranchCode : parsedMetaData.portfolio.branchCode;
      const decodedRequest = JSON.parse(Base64.decode(inputParam));

      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: branchCode,
        reportname: decodedRequest.reportname,
        fromDate: decodedRequest.fromDate,
        toDate: decodedRequest.toDate,
        pfId: decodedRequest.pfId,
      }
      return requestHandler(merge(
        {},
        reqOpts, { url, body }
      ));
    },

    getDistinctDates(inputParam, metaData) {
      const url = getUrl('get-distinct-dates');
      const parsedMetaData = parseRequestMetaData(metaData);

      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
 
      const decodedRequest = JSON.parse(Base64.decode(inputParam));

      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode,
        reportname: decodedRequest.reportname,
        pfId: decodedRequest.pfId
      }

      return requestHandler(merge(
        {},
        reqOpts, { url, body }
      ));
    },


  };

  
}

module.exports = apiFactory;
